import { render, staticRenderFns } from "./act-head.vue?vue&type=template&id=2589079d&scoped=true&"
import script from "./act-head.vue?vue&type=script&lang=js&"
export * from "./act-head.vue?vue&type=script&lang=js&"
import style0 from "./act-head.vue?vue&type=style&index=0&id=2589079d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2589079d",
  null
  
)

export default component.exports